import React, { useEffect, useState } from 'react'
import { useRef } from 'react';
import {
    FormGroup,
    FormControlLabel,
    Checkbox, Typography
} from "@mui/material";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axiosInstance from '../../../../lib/axios';
import checkAndLock from "../../../../GlobalFunction/checkAndLock";
import axios from "../../../../lib/axios";
import UnLock from "../../../../GlobalFunction/UnLock";
import CrudButtons from '../../../../GlobalFunction/CrudButtons';
import ReportTable from '../../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';

const columns = [
    { id: 'RowNum', label: 'S.No.', minWidth: 170 },
    { id: 'EnqTpName', label: 'Enq Type', minWidth: 100 },
    { id: 'EnqAbvr', label: 'Abrv', minWidth: 100 },
    { id: 'Remark', label: 'Remark', minWidth: 100 }
];

const EnqTypeMst = () => {
    const [formData, setFormData] = useState({
        EnqTpName: '',
        EnqAbvr: '',
        Remark: ''
    });

    const [error, setError] = useState({
        EnqTpName: false,
        EnqAbvr: false
    });

    const navigate = useNavigate();

    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const location = useLocation();
    const [CurrentEnqTpId, setCurrentEnqTpId] = useState(null);
    const [mode, setMode] = useState('view');
    const [Status, setStatus] = useState("1");
    const [LastInsertedEnqTpId, setLastInsertedEnqTpId] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
    const [DataForPrint, setDataForPrint] = useState({});
    const [rows, setRows] = useState([]);
    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });

    const enqTpNameRef = useRef(null);
    const enqAbrvRef = useRef(null);
    const remarkRef = useRef(null);

    useEffect(() => {
        if (location.state && location.state.EnqTpId) {
            setCurrentEnqTpId(location.state.EnqTpId);
            fetchEnqType(location.state.EnqTpId);
            setMode('view');
        } else {
            setMode('add');
            setIsFormDisabled(false);
        }
    }, [location]);

    const fetchEnqType = async (id, flag) => {
        try {
            const response = await axiosInstance.post(`MstEnqTp/RetriveMstEnqTp`,
                {
                    EnqTpId: parseInt(id),
                    Flag: flag
                }
            );

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                const enqTypeData = Array.isArray(response.data.Data) ? response.data.Data[0] : response.data.Data;
                if (enqTypeData) {
                    setFormData({
                        EnqTpName: enqTypeData.EnqTpName,
                        EnqAbvr: enqTypeData.EnqAbvr,
                        Remark: enqTypeData.Remark
                    });
                    setStatus(enqTypeData.Status.toString() || "0");
                    setIsFormDisabled(true);
                    setCurrentEnqTpId(enqTypeData.EnqTpId);
                }
            } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
                toast.info(response.data.Message);
            } else {
                toast.error('Failed to fetch enyuiry data');
            }
        } catch (error) {
            console.error('Error fetching enquiry data:', error);
            toast.error('Error fetching enquiry data. Please try again.');
        }
    };

    useEffect(() => {
        const getRow = async () => {
            const params = {
                start: 1,
                PageSize: 1,
                SearchText: ""
            };

            try {
                const res = await axios.post('MstEnqTp/GetMstEnqTpDashboard', { params });

                if (res.data && res.data.Data) {
                    setRows(res.data.Data);
                    setDataForPrint(res.data.Data);
                } else {
                    console.error('No data found in response');
                }
            } catch (err) {
                console.error('Error fetching data:', err);
            }
        };

        getRow();
    }, []);

    const handlePrevious = async () => {
        if (CurrentEnqTpId && CurrentEnqTpId > 1) {
            await fetchEnqType(CurrentEnqTpId, "P");
        }
    };

    const handleNext = async () => {
        if (CurrentEnqTpId) {
            await fetchEnqType(CurrentEnqTpId, "N");
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));

        if (name === 'EnqType') {
            setFormData(prevState => ({
                ...prevState,
                state: ''
            }));
        }

        if (name === 'EnqType' && value !== '') {
            setTimeout(() => {
                remarkRef.current.focus();
            }, 100000);
        }
    };

    const handleChangeStatus = (event) => {
        const updatedStatus = event.target.checked ? "1" : "0";
        setStatus(updatedStatus);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            if (event.target === enqTpNameRef.current) {
                enqAbrvRef.current.focus();
            } else {
                remarkRef.current.focus();
            }
        }
    };

    const handleSubmit = async () => {

        let hasError = false;

        if (!formData.EnqTpName) {
            toast.error('Enq Type is required');
            setError(prev => ({ ...prev, EnqTpName: true }));
            hasError = true;
        } else {
            setError(prev => ({ ...prev, EnqTpName: false }));
        }

        if (hasError) {
            return;
        }

        try {
            const payload = {
                EnqTpName: formData.EnqTpName,
                EnqAbvr: formData.EnqAbvr,
                Remark: formData.Remark,
                Status: Status
            };

            let response;
            if (mode === 'edit') {
                payload.EnqTpId = CurrentEnqTpId;
                payload.UpdatedBy = parseInt(UserId, 10);
                response = await axiosInstance.patch(`MstEnqTp/UpdateMstEnqTp`, payload);
            } else {
                payload.CreatedBy = parseInt(UserId, 10);
                response = await axiosInstance.post(`MstEnqTp/InsertMstEnqTp`, payload);
            }

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message);
                if (mode === 'add') {
                    setLastInsertedEnqTpId(response.data.Data)
                    await fetchEnqType(response.data.Data);
                    setMode('view');
                    setIsFormDisabled(true);
                    setCurrentEnqTpId(response.data.Data);
                } else {
                    setMode('view');
                }
                setIsFormDisabled(true);
            } else {
                toast.error(response.data.Message || 'Operation failed');
            }
        } catch (error) {
            console.error('Error saving/updating enquiry:', error);
            toast.error('Error saving/updating enquiry.');
        }
    };

    const handleEdit = async () => {
        let Flag = await checkAndLock(CurrentEnqTpId, "MstEnqTp", "EnqTpId");
        switch (Flag) {
            case 0:
                setMode("edit");
                setIsFormDisabled(false);
                break;
            case 1:
                toast.info("Record  Already Locked", { autoClose: 500 });
                break;
            case 2:
                toast.info("Record Failed To Locked", { autoClose: 500 });
                break;
            default:
                toast.info("Something Went Wrong", { autoClose: 500 });
        }
    };

    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);
        setFormData({
            EnqTpName: '',
            EnqAbvr: '',
            Remark: ''
        });
        setCurrentEnqTpId(null);

        setTimeout(() => {
            enqTpNameRef.current.focus();
        }, 0);
    };

    const handleCancel = async () => {
        try {
            await fetchEnqType(1, "L");
            await UnLock(CurrentEnqTpId, "MstEnqTp", "EnqTpId");
            setStatus("1");
            setMode('view');
            setIsFormDisabled(true);
        } catch (error) {
            toast.error('Error occurred while cancelling.');
        }
    };

    const resetForm = () => {
        setFormData({
            EnqTpName: '',
            EnqAbvr: '',
            Remark: ''
        });
        setCurrentEnqTpId(null);
        setMode('view');
    };

    const handleExit = () => {
        navigate('/enqtypetable')
    }

    const handleDeleteClick = () => {
        setOpenConfirmDialog(true);
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    const handleConfirmDelete = async () => {
        let Flag = await checkAndLock(CurrentEnqTpId, "MstEnqTp", "EnqTpId");
        switch (Flag) {
            case 0:
                setOpenConfirmDialog(false);
                await fetchEnqType(CurrentEnqTpId, "D");
                await fetchEnqType(CurrentEnqTpId, "N");
                setStatus("1");
                setMode('view');
                setIsFormDisabled(true);
                break;
            case 1: toast.info("Record  Already Locked", { autoClose: 500 });
                break;
            case 2: toast.info("Record Failed To Locked", { autoClose: 500 });
                break;
            default: toast.info("Something Went Wrong", { autoClose: 500 });
        }
    };

    return (
        <>
            <Box className="form-container" sx={{ height: { xs: '700px', sm: '550px' } }}>
                <ToastContainer />
                <Grid container spacing={2} className='form_grid'>
                    <Grid item xs={12} className='form_title'
                        sx={{
                            display: 'flex', alignItems: 'center',
                            justifyContent: 'space-between', marginTop: '20px',
                            flexDirection: { xs: 'column', sm: 'row', md: 'row' }
                        }}
                    >
                        <Grid
                            sx={{
                                display: 'flex',
                                justifyContent: { xs: 'center', sm: 'flex-start' },
                                marginBottom: { xs: '10px', sm: 0 }
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                className='three-d-button-previous'
                                onClick={handlePrevious}
                                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
                                disabled={mode !== 'view' || !CurrentEnqTpId || CurrentEnqTpId === 1}
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>

                            <Button
                                variant="contained"
                                size="small"
                                className='three-d-button-next'
                                onClick={handleNext}
                                sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
                                disabled={mode !== 'view' || !CurrentEnqTpId}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>

                        <Typography
                            variant="h5"
                            sx={{
                                margin: 'Auto',
                                textAlign: { xs: 'center', sm: 'center' },
                                fontSize: { xs: '24px', sm: '18px', md: '24px' }
                            }}
                        >
                            Enquiry Type Master
                        </Typography>

                        <Grid sx={{ display: "flex", justifyContent: "end" }}>
                            <CrudButtons
                                moduleName={"EnqType Master"}
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onView={handlePrint}
                                onDelete={handleConfirmDelete}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={isFormDisabled}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className='form_field'>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={4} lg={3}>
                                <TextField
                                    id="EnqTpName"
                                    name="EnqTpName"
                                    label={
                                        <span>
                                            Enq Type <span style={{ color: 'red' }}>*</span>
                                        </span>
                                    }
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.EnqTpName}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    error={error.EnqTpName}
                                    helperText={error.EnqTpName && ""}
                                    inputRef={enqTpNameRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} lg={3}>
                                <TextField
                                    id="EnqAbvr"
                                    name="EnqAbvr"
                                    label="Abrv"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.EnqAbvr}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    error={error.EnqAbvr}
                                    helperText={error.EnqAbvr && ""}
                                    inputRef={enqAbrvRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>

                            <Grid item xs={12} md={4} lg={3}>
                                <TextField
                                    id="Remark"
                                    name="Remark"
                                    label="Remark"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.Remark}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={remarkRef}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={2}>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                disabled={isFormDisabled}
                                                checked={Status === "1"}
                                                onChange={handleChangeStatus}
                                            />
                                        }
                                        label="Status"
                                    />
                                </FormGroup>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_button">
                        {mode === 'view' && (
                            <>
                                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }} onClick={handleAdd} disabled>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }} onClick={handleEdit}
                                    disabled
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === 'edit' || mode === 'add') && (
                            <>

                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSubmit}>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                                    Cancel
                                </Button>

                            </>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <div style={{ display: 'none' }}>
                {Object.keys(DataForPrint).length > 0 && <ReportTable
                    columns={columns}
                    rows={rows}
                    title="Enq Type"
                    contentRef={contentRef}
                    customStyles={{ backgroundColor: '#f5f5f5' }}
                />
                }
            </div>

            <Dialog
                open={openConfirmDialog}
                onClose={handleCloseConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Confirm Deletion"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: '#1565c0',
                                color: 'white'
                            }
                        }}
                        onClick={handleConfirmDelete}
                    >
                        Yes
                    </Button>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: '#1565c0',
                                color: 'white'
                            }
                        }}
                        onClick={handleCloseConfirmDialog}
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default EnqTypeMst;